module.exports = __webpack_public_path__ + "static/img/cabecera7.dcea6ed3.jpg";